import { Logo } from '@repo/ui/components/logo'
import { cn } from '@repo/ui/lib/utils'
import { env } from '@/lib/config/environment'

interface AuthLayoutProps {
  children: React.ReactNode
  className?: string
}

function AuthShowcase() {
  return (
    <div className="absolute inset-0 overflow-hidden">
      <div className="absolute inset-0 bg-background" />
      <img
        src="/auth/auth-route-background-v5.png"
        alt=""
        aria-hidden="true"
        className="absolute inset-[-2%] h-[104%] w-[104%] max-w-none object-cover object-[48%_50%] opacity-90"
        style={{ filter: 'saturate(0.92) contrast(0.98) brightness(1.01)' }}
      />
      <div className="absolute inset-0 bg-gradient-to-l from-background/90 via-background/58 to-background/8" />
      <div className="absolute inset-0 bg-gradient-to-b from-background/12 via-transparent to-foreground/8" />
      <div className="app-noise absolute inset-0 opacity-10" />
    </div>
  )
}

export function AuthLayout({ children, className }: AuthLayoutProps) {
  return (
    <div className="relative min-h-svh overflow-hidden bg-background">
      <AuthShowcase />

      <div className="relative z-10 min-h-svh lg:grid lg:grid-cols-[1fr_minmax(34rem,46vw)]">
        <div className="hidden lg:block" />
        <div className="relative flex min-h-svh flex-col px-6 pb-8 pt-6 md:px-12 md:pb-10 md:pt-8">
          <div className="mx-auto flex w-full max-w-[30rem] flex-1 flex-col lg:mr-auto">
            <div className="flex items-center">
              <a
                href={env.VITE_WEB_URL}
                className="inline-flex items-center gap-3 px-1 py-1 transition-opacity duration-200 hover:opacity-80"
              >
                <Logo className="h-7 w-7" />
                <span className="text-[1.02rem] font-semibold tracking-tight text-foreground">
                  Zippity
                </span>
              </a>
            </div>

            <div className="flex flex-1 items-center py-8 lg:py-10">
              <div className="w-full max-w-[30rem]">
                <div className={cn('', className)}>{children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
